<template>
  <wrap-container>
    <help-title title="Cuentas y paquetes" />

    <help-list-container>
      <help-list-item tituloLista="Teléfonos útiles:">
        Estos son los teléfonos útiles o mail de contacto para que nuestros
        asesores especializados puedan ayudarte. Comunicate con nosotros al
        <strong>0810-222-0000</strong> de 8 a 21 hs o escribinos a
        <strong>televentas-arg@bbva.com</strong>.
      </help-list-item>

      <help-list-item tituloLista="Más información:">
        Encontrá más información sobre cuentas y paquetes en nuestro sitio
        <custom-link
          label="Ver más Información"
          href="https://www.bbva.com.ar/personas/productos/cuentas.html"
        />
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import CustomLink from "@/components/core/CustomLink";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    CustomLink
  }
};
</script>
